module.exports = __webpack_public_path__ + "img/will_s.3381a807.png";